import React, { useState, useEffect } from "react";
import { ISearchMessageProps } from "./SearchMessageProps";
import { Wrapper, Message } from "./SearchMessageHelpers";

const SearchMessage: React.FC<ISearchMessageProps> = ({
  hotelCount,
  searchString,
  priceFilter,
}) => {
  const [message, setMessage] = useState("");
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let didCancel = false;
    let newMessage = `We did not find any Sonesta hotels within 50 miles of your search location. Please try another destination or visit <a href="/locations">Sonesta Locations</a> for a full list of hotels.`;
    let quantity = null;
    // if (hotelCount >= 1) {
    if (priceFilter !== null) {
      switch (priceFilter) {
        case "under_50":
          newMessage = `Hotels under $50 near ${searchString}`;
          break;
        case "between_50_100":
          newMessage = `Hotels $50-$100 near ${searchString}`;
          break;
        case `over_100`:
          newMessage = `Hotels over $100 near ${searchString}`;
          break;
        default:
          newMessage = `We did not find any Sonesta hotels within 50 miles of your search location. Please try another destination or visit <a href="/locations">Sonesta Locations</a> for a full list of hotels.`;
      }
    } else {
      quantity = hotelCount;
      newMessage =
        hotelCount && hotelCount > 0
          ? `hotel${hotelCount === 1 ? "" : "s"}`
          : `We did not find any Sonesta hotels within 50 miles of your search location. Please try another destination or visit <a href="/locations">Sonesta Locations</a> for a full list of hotels.`;
    }
    // }
    if (!didCancel) {
      setCount(Number(quantity));
      setMessage(newMessage);
    }
    return () => {
      didCancel = true;
    };
  }, [hotelCount, searchString, priceFilter]);

  return (
    <>
      <Wrapper>{`${count > 0 ? count : ""} ${message}`}</Wrapper>
      <Message id="search-result-header">
        {count > 0 && count}{" "}
        <span
          id="font-weight-medium"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </Message>
    </>
  );
};
export default SearchMessage;
